<app-modal-refactor
  [size]="'lg'"
  [showImage]="true"
  [image]="icon"
  [isVerPass]="true"
>
  <div body class="boardingPassLowPaper">
    <span class="boardingPassLowPaper-title gapline">{{ titleKey | translate }}</span>

    <div class="boardingPassLowPaper-actions gapline">
      <button
        type="button"
        class="boardingPassLowPaper-btn search-bg white-font"
        (click)="onContinue()"
      >
        <div class="boardingPassLowPaper-btn-container">
          <span>{{ ctaKey | translate }}</span>
        </div>
      </button>
    </div>
  </div>
</app-modal-refactor>
